export const ORDER_EPP_KEY_MODAL_STEP = {
  SELECT_DOMAIN: 'SELECT_DOMAIN',
  CONFIRM_ORDER: 'CONFIRM_ORDER',
  KEY_SUCCESS: 'KEY_SUCCESS',
  KEY_FAILURE: 'KEY_FAILURE',
  LOADING_KEY: 'LOADING_KEY',
};
